module.exports = __webpack_public_path__ + "img/ИФ-1(А)-020.9d2ba9ce.png";